import React, { useState, useEffect } from 'react'
import {
    MDBCard,
    MDBCardBody,
    MDBInput,
    MDBCardFooter,
    MDBValidation,
    MDBBtn,
    MDBIcon,
    MDBSpinner,
} from "mdb-react-ui-kit";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify'
import { googleSignIn, login } from '../redux/feature/authSlice';
import { GoogleLogin } from 'react-google-login'

const initialState = {
    email: "",
    password: ""
}

const Login = () => {
    const [formValue, setFormValue] = useState(initialState);
    const { loading, error } = useSelector((state) => ({ ...state.auth }))
    const { email, password } = formValue
    const dispatch = useDispatch()
    const navigate = useNavigate()
    //1047014699333-sre88uq93eo17p3elkbvcqf6qgu9ln6v.apps.googleusercontent.com ---> prod

    const devEnv = process.env.NODE_ENV !== "production";
    const clientId = devEnv
        ? "1047014699333-7n7gb7uteu5tcsq7d5cqgvp4jg0ne6l4.apps.googleusercontent.com"
        : "1047014699333-sre88uq93eo17p3elkbvcqf6qgu9ln6v.apps.googleusercontent.com";

    useEffect(() => {
        error && toast.error(error)
    }, [error])

    const handleSubmit = (e) => {
        e.preventDefault();
        if (email && password) {
            dispatch(login({ formValue, navigate, toast }))
        }
    }
    const onInputChange = (e) => {
        let { name, value } = e.target;
        setFormValue({ ...formValue, [name]: value })
    }

    const googleSuccess = (resp) => {
        const email = resp?.profileObj?.email;
        const name = resp?.profileObj?.name;
        const token = resp?.tokenId;
        const googleId = resp?.googleId;
        const result = { email, name, token, googleId }
        dispatch(googleSignIn({ result, navigate, toast }))
    }
    const googleFailure = (error) => {
        toast.error(error)
    }
    return (
        <div
            style={{
                margin: "auto",
                padding: "15px",
                maxWidth: "450px",
                alignItems: "center",
                marginTop: "120px",
            }}
        >
            <MDBCard alignment='center'>
                <MDBIcon fas icon='user-circle' className='fa-2x' />
                <h5>Sign In</h5>
                <MDBCardBody>
                    <MDBValidation onSubmit={handleSubmit} noValidate className='row g-3'>
                        <div className='col-md-12'>
                            <MDBInput
                                icon='user'
                                label='Email'
                                type='email'
                                value={email}
                                name='email'
                                onChange={onInputChange}
                                required
                                invalid
                                validation='please provide your email'
                                autoComplete='off'
                            />
                        </div>
                        <div className='col-md-12'>
                            <MDBInput
                                label='Password'
                                type='password'
                                value={password}
                                name='password'
                                onChange={onInputChange}
                                required
                                invalid
                                validation='please provide your password'
                            />
                        </div>
                        <div className='col-12'>
                            <MDBBtn style={{ width: '100%' }} className='mt-2'>
                                {loading && (
                                    <MDBSpinner
                                        size='sm'
                                        role='status'
                                        tag='span'
                                        className='me-1'
                                    />
                                )}
                                Login
                            </MDBBtn>
                        </div>
                    </MDBValidation>
                    <br />
                    <GoogleLogin
                        clientId={clientId}
                        render={(renderProps) => (
                            <MDBBtn
                                style={{ width: '100%', color: "danger" }}
                                color="danger"
                                onClick={(renderProps.onClick)}
                                disabled={(renderProps.disabled)}
                            >
                                <MDBIcon className='ma-2' fab icon='google' /> Google Sign In
                            </MDBBtn>
                        )}
                        onSuccess={googleSuccess}
                        onFailure={googleFailure}
                        cookiePolicy="single_host_origin"
                    />
                </MDBCardBody>
                <MDBCardFooter>
                    <Link to='/register'>
                        <p>Don't have an account ? Sign Up</p>
                    </Link>
                </MDBCardFooter>
            </MDBCard>
        </div>
    );
}

export default Login